<template>
  <div class="share-common-footer" :style="{width:pc_width_580 }" v-if="isShow">
    <div class="share-common-footer-title">
      <span>分享至</span>
    </div>
    <div class="share-common-footer-list">
      <template v-if="isInApp">
        <div class="share-common-footer-list-item" @click="$emit('sharePyq')">
          <img class="tips_icon" src="@/assets/images/sharePYQ.png" />
          <span>朋友圈</span>
        </div>
        <div class="share-common-footer-list-item" @click="$emit('shareWx')">
          <img class="tips_icon" src="@/assets/images/shareWX.png" />
          <span>微信好友</span>
        </div>
      </template>
      <template v-if="!isUrl">
        <div class="share-common-footer-list-item" @click="$emit('shareCard')">
          <img class="tips_icon" src="@/assets/images/shareImg.png" />
          <span>分享海报</span>
        </div>
        <div class="share-common-footer-list-item copy" @click="shareLink">
          <img class="tips_icon" src="@/assets/images/shareLink.png" />
          <span>复制链接</span>
        </div>
      </template>
    </div>
    <div class="share-common-footer-cancle" @click="$emit('cancle')">
      <span>取消</span>
    </div>
  </div>
</template>

<script>
import os from '@/js/pc'
export default {
    props: {
        isShow: {},
        isUrl: {},
        link: {}
    },
    computed: {
        isInApp() {
            return navigator.userAgent.indexOf('YPAPP') !== -1
        },
        pc_width_580() {
            return os.isPC() ? '580px' : '100%'
        }
    },
    mounted() {
        import('@/js/clipboard.min.js')
    },
    data() {
        return {}
    },
    methods: {
        shareLink() {
            import('@/js/clipboard.min.js').then(res => {
                const clipboard = new res.default('.copy', {
                    text: _ =>
                        `https://${window.location.host}/#/DoctorProduction?production_id=${this.$route.query.production_id}`
                })
                clipboard.on(
                    'success',
                    function(e) {
                        this.$emit('shareLink')
                        this.$toast('复制成功')
                        e.clearSelection()
                    }.bind(this)
                )
            })
            this.$emit('copyLink')
        }
    }
}
</script>

<style  scoped>
.share-common-footer {
    display: flex;
    align-items: center;
    flex-direction: column;
    width: 100%;
    height: 10rem;
    overflow: hidden;
}
.share-common-footer-title {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 1.75rem;
    background: #f1f1f5;
    border-radius: 0.51rem 0.51rem 0rem 0rem;
}
.share-common-footer-title span {
    font-size: 0.6rem;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.65);
}
.share-common-footer-list {
    width: 100%;
    padding: 0.6rem 2.14rem;
    display: flex;
    align-items: center;
    justify-content: space-around;
    height: 4.67rem;
    background: #f1f1f5;
}
.share-common-footer-list-item {
    cursor: pointer;
    display: flex;
    align-items: center;
    flex-direction: column;
}
.share-common-footer-list-item img {
    width: 2.14rem;
    height: 2.14rem;
    border-radius: 100%;
}
.share-common-footer-list-item span {
    margin-top: 0.21rem;
    font-size: 0.51rem;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.65);
}
.share-common-footer-cancle {
    cursor: pointer;
    width: 100%;
    height: 1.88rem;
    background: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
}
.share-common-footer-cancle span {
    font-size: 0.6rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #888888;
}
</style>